import type { InputHTMLAttributes, ReactNode } from 'react';

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label: ReactNode;
}

export function Checkbox({ label, ...input }: CheckboxProps) {
  return (
    <label className="choice choice--plain">
      <input type="checkbox" {...input} />
      <span>{label}</span>
    </label>
  );
}
